module.exports = __webpack_public_path__ + "img/settings_menu_invoiceweb.940572f4.png";